// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
import hashSigns from './hashSigns';
import regexSupplant from '../lib/regexSupplant';
var endHashtagMatch = regexSupplant(/^(?:#{hashSigns}|:\/\/)/, {
  hashSigns: hashSigns
});
export default endHashtagMatch;